import { render } from "./RowHead.vue?vue&type=template&id=cddff8f6&scoped=true&ts=true"
import script from "./RowHead.vue?vue&type=script&lang=ts"
export * from "./RowHead.vue?vue&type=script&lang=ts"

import "./RowHead.vue?vue&type=style&index=0&id=cddff8f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cddff8f6"]])

export default __exports__